export const DocumentsIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.4923 2.50003C11.9571 2.50003 12.4023 2.689 12.7243 3.02479L15.8834 6.31612C16.1892 6.63406 16.3596 7.05825 16.3596 7.49947V14.3027C16.3717 16.0166 15.0237 17.4302 13.3123 17.5L6.70776 17.4992C4.98018 17.4611 3.61109 16.0303 3.64921 14.3027V5.54722C3.68976 3.84803 5.08238 2.49273 6.78239 2.50003H11.4923Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.8906 2.55225V4.96275C11.8899 6.1388 12.842 7.09425 14.0189 7.09669H16.3013"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
